/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import MikeTab from '../../mike-tab';
import BoundaryLine from '../../../icons/BoundaryLine.svg?react'
import History from '../../../icons/History.svg?react'
import ForefrontAlt from '../../../icons/ForefrontAlt.svg?react'
import BoundarySelection from './BoundarySelection';
import InitialSelection from './InitialSelection';
import ForcingSelection from './ForcingSelection';
import mikeSharedTheme from '../../../styles/mikeSharedTheme';

const TAB_IDS = {
  BOUNDARY: 'boundary',
  FORCINGS: 'forcings',
  INITIAL: 'initial',
};

interface IProps {
  selectedTab?: (val: string) => void;
}

/* const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: 360,
  },
  tab: {
    minWidth: 80,
    width: 120,
    maxWidth: 120,
    minHeight: 80,
    height: 80,
    maxHeight: 80,
  },
}); */

const rootStyle = css`
  flex-grow: 1;
  max-width: 360px;
`;

const tabHeight = `${mikeSharedTheme.spacing(7)}px`;
const dsStyles = css`
  .MuiTabs-root {
    height: ${tabHeight}; /* 56px; */
    .MuiButtonBase-root {
      height: ${tabHeight}; /* 56px; */
      .MikeTooltip--span {
        margin-top: -9px;
      }
      &:hover {
        background-color: #f2f5f7;
      }
    }
  }
`;

const DLDataSelectionPanel = (props: IProps) => {
  
  const [value, setValue] = useState(TAB_IDS.BOUNDARY);

  function handleChange(_event, newValue: string) {
    setValue(newValue);
    props.selectedTab(newValue);
    // console.log('newValue: ', newValue);
  }

  return (
    <div className={`menuExtractionContainer ${dsStyles}`}>
      <Paper square css={rootStyle}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          style={{ minHeight: '58px' }}>
          <MikeTab
            tooltipTitle="Data provider selection for MIKE bundary conditions extraction"
            label={<span>{"Boundary"}</span>}
            icon={<BoundaryLine />}
            value={TAB_IDS.BOUNDARY}
          />
          <MikeTab
            tooltipTitle="Data provider selection for MIKE initial conditions extraction"
            label={<span>{"Initial"}</span>}
            icon={<History />}
            value={TAB_IDS.INITIAL}
          />
          <MikeTab
            tooltipTitle="Data provider selection for (Meteo) model forcings extraction"
            label={<span>{"Forcings"}</span>}
            icon={<ForefrontAlt />}
            value={TAB_IDS.FORCINGS}
          />
        </Tabs>
      </Paper>
      <div>
        <div className={value === TAB_IDS.BOUNDARY ? '' : 'hidePanel'}>
          <BoundarySelection />
        </div>
        <div className={value === TAB_IDS.FORCINGS ? '' : 'hidePanel'}>
          <ForcingSelection />
        </div>
        <div className={value === TAB_IDS.INITIAL ? '' : 'hidePanel'}>
          <InitialSelection />
        </div>
      </div>
    </div>
  );
};
const DataSelectionPanel = React.memo(DLDataSelectionPanel);
export { DataSelectionPanel }; // Because issues with export in ´./index.ts´
export default React.memo(DLDataSelectionPanel);
